export function debounce<Args extends unknown[], Return>(
  func: (...args: Args) => Return,
  wait = 300
): (...args: Args) => void {
  let timeout: ReturnType<typeof setTimeout> | null = null

  return function (...args: Args): void {
    const later = () => {
      timeout = null
      func(...args)
    }

    if (timeout !== null) {
      clearTimeout(timeout)
    }

    timeout = setTimeout(later, wait)
  }
}
